import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CensusPatientListService } from '../../census-patient-list/census-patient-list.service';

@Component({
  selector: 'app-capture-scriptsure-email-dialog',
  templateUrl: './capture-scriptsure-email-dialog.component.html',
  styleUrls: ['./capture-scriptsure-email-dialog.component.css']
})
export class CaptureScriptSureEmailDialogComponent {
  emailForm: FormGroup;
  loginData: any;

  constructor(
    private censusPatientListService: CensusPatientListService,
    private _toastr: ToastrService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CaptureScriptSureEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { scriptSureEmail?: string }
  ) {
    this.emailForm = this.fb.group({
      email: [data?.scriptSureEmail || '', [Validators.required, Validators.email]]
    });
  }

  async onSubmit() {
    if (this.emailForm.valid) {
      if(await this.validateEmail()) {
        this.dialogRef.close({
          scriptSureEmail: this.emailForm.get('email').value,
          loginData: this.loginData
        });
      }
    }
  }

  async validateEmail() {
    let scriptSureEmail = this.emailForm.get('email').value;
    this._toastr.info("Validating ScriptSure email " + scriptSureEmail + " is registered with ScriptSure...");
    let response: any = await this.censusPatientListService.checkIfScriptSureEmailRegistered(scriptSureEmail);
    if(!response.data || !response.data.registered){
      this._toastr.error(response.message, null, {
        timeOut: 3000,
        closeButton: true,
      });
      return false;
    } 

    this.loginData = response.data.loginData;
    return true;
  }

  onCancel() {
    this.dialogRef.close();
  }
} 
